/**
 *
 * @module contentClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ContentClientEndpoint
 * @type {Object}
 *
 * @property {String} bookmarks
 * @property {String} bookmarksPersisted
 * @property {String} catalog
 * @property {String} search
 * @property {String} searchPersisted
 * @property {String} searchSuggestions
 * @property {String} sportsData
 * @property {String} sportsDataPersisted
 * @property {String} watchlist
 * @property {String} watchlistPersisted
 * @property {String} autoSuggest
 *
 */

/**
 *
 * @enum
 * @type {ContentClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    bookmarks: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    bookmarksPersisted: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    catalog: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    search: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    searchPersisted: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    searchSuggestions: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    sportsData: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    sportsDataPersisted: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    watchlist: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    watchlistPersisted: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    autoSuggest: null
});



// WEBPACK FOOTER //
// ./src/services/content/contentClientEndpoint.js